export default function powerBIReducer(state: any = [], action: any) {
    switch (action.type) {
        case 'load_report_success':
            return { ...state, reports: action.data.reports, folders: action.data.folders };
        case 'power_bi_api_token_success':
            return { ...state, powerBIReportToken: action.token };
        case 'user_token_success':
            return { ...state, userToken: action.userToken }
        case 'get_report_success':
            return { ...state, report: action.report };
        case 'get_port_parameters_success':
            return { ...state, portParameters: action.portParameters };
        case 'fnt_dashboards':
            return { ...state, fntDashboards: action.fntDashboards };
        case 'fnt_user_token':
            return {...state, fntUserToken: action.token}
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/powerBIReducer.tsx